export default __webpack_public_path__ + "static/media/print.e697546c.svg";